import type { IncomingCall } from '../../types/ring';
import { hoursSegments } from '../../utils/listening';

/** The listener line's words (D56: never "on call"). */
export const LISTENER_COPY = {
  listens: (hours: string) => `Listens ${hours}`,
  calls: (n: number) => (n === 1 ? '1 call' : `${n} calls`),
} as const;

/**
 * "Listens Mon 9 am–12 pm MDT · 12 calls": the caller's profile line, the
 * hours' zone named as the server sends it, only what
 * their profile already shows the viewer (the server sends nothing else).
 * The first window of a longer schedule, then "+N more". Null when there is
 * nothing to say.
 */
export function listenerLine(listener: IncomingCall['listener']): string | null {
  if (!listener) return null;
  const parts: string[] = [];
  const segments = hoursSegments(listener.hours);
  if (segments.length > 0) {
    const first = segments[0];
    const more = segments.length > 1 ? ` +${segments.length - 1} more` : '';
    const zone = listener.zone_label ? ` ${listener.zone_label}` : '';
    parts.push(
      LISTENER_COPY.listens(`${first.days ? `${first.days} ` : ''}${first.range}${zone}${more}`),
    );
  }
  if (listener.calls !== null && listener.calls > 0)
    parts.push(LISTENER_COPY.calls(listener.calls));
  return parts.length > 0 ? parts.join(' · ') : null;
}
